import { render, staticRenderFns } from "./ButtonsList.vue?vue&type=template&id=704e5bb3"
import script from "./ButtonsList.vue?vue&type=script&lang=js"
export * from "./ButtonsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports